import { tOrderApi } from "./services/tOrderApi";
import tOrderReducer from "./slices/tOrderSlice";

export const tReducer = {
    [tOrderApi.reducerPath]: tOrderApi.reducer,
    tOrders: tOrderReducer,
};
export const tMiddleware = [tOrderApi.middleware];
